import React, { useMemo } from 'react';
import './App.scss';
import cn from 'classnames';
import { createRoutesFromElements, Route } from 'react-router';
import { RouterProvider, createHashRouter } from 'react-router-dom';
import Section from '../ui/pages/Section';
import Results from '../ui/pages/Results';
import MasterLayout from '../ui/layouts/MasterLayout';
import EntryPageList from '../components/EntryPage/EntryPageList';
import { store } from '../app/store';

import Callback from '../components/Callback';
import SilentRenew from '../components/SilentRenew';

function App() {
  const basename = useMemo(() => store.getState().base.baseName, []);

  const routes = createRoutesFromElements(
    <>
      <Route element={<MasterLayout />}>
        <Route path="/" element={<EntryPageList />} />
        <Route path="/:sectionName" element={<Section />} />
        <Route path="/:sectionName/results" element={<Results />} />
        {/* Catch-all route to redirect to home or a 404 page */}
      </Route>
      <Route path="/auth/callback" element={<Callback />} />
      <Route path="/auth/silent-renew" element={<SilentRenew />} />
    </>,
  );

  return (
    <div className={cn('fr ems', { 'fwe-pt-6': false })}>
      <RouterProvider router={createHashRouter(routes, { basename })} />
    </div>
  );
}

export default App;
